import { useEffect, useRef, useCallback } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";

export const usePersonAnimation = (
  animations: THREE.AnimationClip[],
  animationRef: React.RefObject<THREE.Object3D | null>
) => {
  const mixerRef = useRef<THREE.AnimationMixer | null>(null);

  const changeAnimation = useCallback((animationIndex: number) => {
    if (mixerRef.current && animations && animations.length > animationIndex) {
      try {
        mixerRef.current.stopAllAction();
        const actionCurrent = mixerRef.current.clipAction(animations[animationIndex]);
        actionCurrent.play();
      } catch (error) {
        console.warn("Animation error:", error);
      }
    }
  }, [animations]);

  // Initialize mixer
  useEffect(() => {
    if (animations && animations.length > 0 && animationRef.current) {
      mixerRef.current = new THREE.AnimationMixer(animationRef.current);
      // Play the walk animation by default
      changeAnimation(1);
    }
    return () => {
        if (mixerRef.current) {
            mixerRef.current.stopAllAction();
        }
    }
  }, [animations, animationRef, changeAnimation]);

  // Update mixer frame by frame
  useFrame((_, delta) => {
    if (mixerRef.current) {
      mixerRef.current.update(delta);
    }
  });

  return { changeAnimation };
};

